const MAX_FRAME_NUM = 295;

const heroFrameUrls: string[] = Array.from({ length: MAX_FRAME_NUM }, (_, i) => i + 1).map(
  (frameNum) => {
    const n = String(frameNum).padStart(3, "0");
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const mod = require(`./birdfly_frames/${n}.png`);
    return (typeof mod === "string" ? mod : mod.default) as string;
  }
);

export default heroFrameUrls;
